import React, { useState, useEffect } from "react";
import { Avatar, Box, Skeleton, SxProps, Theme } from "@mui/material";

import useAppStore from "../../../stores/appStore";
import useUserStore from "../../../stores/userStore";
import { useAuthenticatedFileUrl } from "../../../hooks/useAuthenticatedFileUrl";

type UserAvatarProps = {
  size: string;
  sx?: SxProps<Theme>;
  name?: string;
  img?: string;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  size,
  sx,
  name,
  img,
}) => {
  const { url: resolvedImg } = useAuthenticatedFileUrl(img);
  const { user } = useUserStore();
  const { userAvatar } = useAppStore();
  const [displayName, setDisplayName] = useState<string>("");
  const [imgLoaded, setImgLoaded] = useState<boolean>(!resolvedImg);

  useEffect(() => {
    setDisplayName(name ?? user.first_name);
  }, [name, user.first_name]);

  useEffect(() => {
    setImgLoaded(!resolvedImg);
  }, [resolvedImg]);

  return (
    <Box sx={{ position: "relative", width: size, height: size }}>
      {resolvedImg && !imgLoaded && (
        <Skeleton
          variant="circular"
          width={size}
          height={size}
          animation="wave"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
            ...sx,
          }}
        />
      )}
      <Avatar
        src={resolvedImg}
        imgProps={{
          onLoad: () => setImgLoaded(true),
          onError: () => setImgLoaded(true),
        }}
        sx={{
          width: size,
          height: size,
          bgcolor: "#60A5FA",
          color: "#fff",
          objectFit: "cover",
          visibility: resolvedImg && !imgLoaded ? "hidden" : "visible",
          ...sx,
        }}
      >
        {!resolvedImg && !userAvatar && displayName ? displayName[0] : ""}
      </Avatar>
    </Box>
  );
};
